import { useState, useEffect } from "react";
import { getTableData, getTableSummary } from "../services/api";
import DataTable from "./DataTable";
import SummaryCharts from "./SummaryCharts";

const PAGE_SIZE = 50;

export default function TableExplorer({ schema, table }) {
  const [tab, setTab] = useState("data");
  const [data, setData] = useState(null);
  const [summary, setSummary] = useState(null);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setOffset(0);
    setData(null);
    setSummary(null);
  }, [schema, table]);

  useEffect(() => {
    if (tab === "data") {
      setLoading(true);
      setError(null);
      getTableData(schema, table, PAGE_SIZE, offset)
        .then((r) => setData(r.data))
        .catch((e) => setError(e.response?.data?.detail || e.message))
        .finally(() => setLoading(false));
    }
  }, [schema, table, offset, tab]);

  useEffect(() => {
    if (tab === "charts" && !summary) {
      setLoading(true);
      getTableSummary(schema, table)
        .then((r) => setSummary(r.data))
        .catch((e) => setError(e.response?.data?.detail || e.message))
        .finally(() => setLoading(false));
    }
  }, [tab, schema, table, summary]);

  return (
    <div>
      <div style={{ display: "flex", gap: 4, marginBottom: 18, borderBottom: "1px solid var(--border)" }}>
        {["data", "charts"].map((t) => (
          <button
            key={t}
            onClick={() => setTab(t)}
            style={{
              padding: "8px 18px",
              background: "transparent",
              border: "none",
              borderBottom: tab === t ? "2px solid var(--accent)" : "2px solid transparent",
              color: tab === t ? "var(--accent)" : "var(--text-muted)",
              cursor: "pointer",
              fontWeight: tab === t ? 600 : 400,
              fontSize: 14,
              marginBottom: -1,
            }}
          >
            {t === "data" ? "Veri" : "Grafikler"}
          </button>
        ))}
      </div>

      {loading && (
        <div style={{ color: "var(--text-muted)", fontSize: 14, padding: "20px 0" }}>Yükleniyor...</div>
      )}
      {error && (
        <div style={{ color: "#fca5a5", fontSize: 14, background: "#450a0a", padding: "10px 14px", borderRadius: 8 }}>
          {error}
        </div>
      )}

      {!loading && !error && tab === "data" && data && (
        <DataTable
          columns={data.columns}
          rows={data.rows}
          total={data.total}
          limit={PAGE_SIZE}
          offset={offset}
          onPageChange={setOffset}
        />
      )}

      {!loading && !error && tab === "charts" && summary && (
        <SummaryCharts summary={summary} />
      )}
    </div>
  );
}
